import { v4 as uuidv4 } from "uuid";
import {
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDocs,
  getFirestore,
  QueryDocumentSnapshot,
  setDoc,
  SnapshotOptions,
} from "firebase/firestore";

export class Message {
  id: string;
  header: string;
  message: string;
  isActive: boolean;

  constructor(header: string, message: string, isActive: boolean) {
    this.id = uuidv4();
    this.header = header;
    this.message = message;
    this.isActive = isActive;
  }
}

export const messageConverter = {
  toFirestore(post: Message): DocumentData {
    return {
      id: post.id,
      header: post.header,
      message: post.message,
      isActive: post.isActive,
    };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): Message {
    const data = snapshot.data(options)!;

    const message = new Message(data.header, data.message, data.isActive);

    message.id = data.id;

    return message;
  },
};

export function listMessage() {
  const db = getFirestore();
  const ref = collection(db, "messages").withConverter(messageConverter);
  return getDocs(ref);
}

export function saveMessage(message: Message) {
  const db = getFirestore();
  const ref = doc(db, "messages", message.id).withConverter(messageConverter);
  return setDoc(ref, message);
}


export function deleteMessage(message: Message) {
  const db = getFirestore();
  const ref = doc(db, "messages", message.id)
  return deleteDoc(ref);
}
